import React, { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import ItemBadgeWrapper from './ItemBadgeWrapper';
const TagsItemBadge = ({ filter, handleClose, scrollY, onPress, isActiveKeyboard, scrollToItem }) => {
    const Content = useMemo(() => {
        const filterLength = filter.length;
        if (filterLength === 1)
            return <Text Text-14>{`#${filter[0].label}`}</Text>;
        return <Text Text-14>{`# ${filterLength} tags`}</Text>;
    }, [filter]);
    return (<ItemBadgeWrapper scrollY={scrollY} handlePress={onPress} onCancel={handleClose} scrollToItem={scrollToItem} isActiveKeyboard={isActiveKeyboard}>
      <View style={styles.container}>{Content}</View>
    </ItemBadgeWrapper>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
export default memo(TagsItemBadge);
